import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ListModal } from 'src/app/features/multi-auction-bidder/core/modal/list-modal';
import { interval, Subscription } from 'rxjs';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { ConfigService } from 'src/app/core/service/config.service';
import { RoomDetailesModal } from 'src/app/features/multi-auction-bidder/core/modal/roomDetailes-modal';
import { SocketEventType } from 'src/app/features/bidders/core/modal/socket-event-type';
import { BidderList } from 'src/app/features/multi-auction-bidder/core/modal/bidders-list';

@Component({
  selector: 'app-actions-bidding-multi',
  templateUrl: './actions-bidding-multi.component.html',
})
export class ActionsBiddingMultiComponent implements OnInit {
  @Input() itemDetails: ListModal | any;
  @Input() roomdetails: RoomDetailesModal | any;
  @Input() auctionRemainingTime: any;
  @Input() activeAuctionWork: any;
  @Input() auctionRemainingTimeNoBid: any;
  @Input() listBidders: any;

  @Output() newBidding = new EventEmitter<any>();
  minus = false;
  CustomPrice = 0;
  subscriptions: Subscription[] = [];
  number!: number;
  duration = 90;
  showTimer = true;
  remainingTimeMinutes = 0;
  remainingTimeSeconds = 0;
  media = new Audio('assets/sound/Notification.mp3');
  constructor(public socket: SocketService, public _config: ConfigService) {}

  ngOnInit() {
    this.number = this.itemDetails?.minimum_price;

    this.CustomPrice = this.itemDetails?.minimum_price;

    this.socket.ListenOnAuctionSocket(this.roomdetails.id);

    this.subscriptions.push(
      this.socket
        .getDataStream<string>(`${this.roomdetails.id}`)
        .subscribe((message) => {
          this.number = message.data.response.item.price;
          this.CustomPrice = message.data.response.item.price;

          this.newBidding.emit(message.data.response.item);
          this.media.play();
        })
    );
    this.subscriptions.push(
      this.socket
        .getDataStream<string>(SocketEventType.Get_Bidders)
        .subscribe((message) => {
          if (message.data.length > 0) {
            this.number = message.data[0].price;
            this.CustomPrice = this.number = message.data[0].price;
          }
        })
    );

    this.priceNotVaild();
  }
  ngOnChanges(changes: SimpleChanges): void {
    // debugger
    // console.log(changes);

    //this.number = this.itemDetails?.minimum_price;

    if (this.auctionRemainingTime) {
    }

    if ('auctionRemainingTime' in changes) {
      if (this.activeAuctionWork == this.itemDetails.id) {
        // this.auctionRemainingTime = 90;
      }
    }
    if ('listBidders' in changes) {
      if (this.activeAuctionWork == this.itemDetails.id) {

        this.duration = changes['listBidders'].currentValue?.length > 1 ? 30 : 90;
      }
    }
    if ('auctionRemainingTimeNoBid' in changes) {
      if (this.auctionRemainingTimeNoBid) {
        if (
          this.auctionRemainingTimeNoBid?.remainingStart == 0 ||
          this.activeAuctionWork != this.itemDetails?.id
        ) {
          this.showTimer = false;
        }

        if (
          this.auctionRemainingTimeNoBid?.remainingStart > 0 &&
          this.activeAuctionWork == this.itemDetails?.id
        ) {
          this.showTimer = true;
          this.remainingTimeMinutes = Math.floor(
            this.auctionRemainingTimeNoBid?.remainingStart / 60
          );
          this.remainingTimeSeconds =
            this.auctionRemainingTimeNoBid!.remainingStart % 60;
        }
      }
    }

    if ('itemDetails' in changes) {
      this.CustomPrice = changes['itemDetails']?.currentValue?.minimum_price;
    }
  }

  priceNotVaild() {
    this.subscriptions.push(
      this.socket
        .getDataStream<string>(SocketEventType.Price_Not_Valid)
        .subscribe((message) => {
          this._config.toastrService.clear();
          this._config.showToastr(
            this._config.translate.instant(
              'Auction Item.Another bidder bid on this price'
            )
          );
        })
    );
    // this.socket?.socket?.on('priceNotVaild', (data: any) => {
    // })
  }
  onSendCustomPrice() {
    this.onAddPrice(Math.round(this.CustomPrice - this.number));
  }
  onAddCustomPrice(type: string, price: number) {
    const number =
      type == 'plus'
        ? Math.round(Number(this.CustomPrice) + Number(price))
        : Math.round(Number(this.CustomPrice) - Number(price));
    console.log(price, number);
    if (type == 'minus') {
      this.minus = number == this.number ? true : false;
    }
    this.CustomPrice = number;
  }

  onAddPrice(price: number) {
    console.log(this.number);

    const dataSend = {
      auctionID: this.itemDetails.id,
      price: Math.round(Number(this.number) + Number(price)),
      roomID: this.roomdetails.id,
      auth: this._config.getAuthUserInfo().user,
    };

    this.socket?.socket?.emit('newBidding', dataSend);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
